module.exports = __webpack_public_path__ + "img/19.e9e223c2.jpg";